import { useCallback, useState } from 'react';

export interface ToggleFunctions {
    toggleOn: () => void;
    toggleOff: () => void;
    toggle: () => void;
}

function useToggle(defaultToggle: boolean): [boolean, ToggleFunctions] {
    const [isOn, setToggle] = useState(defaultToggle);

    const toggle = useCallback(() => setToggle((status) => !status), [setToggle]);
    const toggleOn = useCallback(() => setToggle(true), [setToggle]);
    const toggleOff = useCallback(() => setToggle(false), [setToggle]);

    return [isOn, { toggleOn, toggleOff, toggle }];
}

export default useToggle;
